import personaService from '@/servicios/persona'
import { ERROR_OBTENER_DATOS_PERSONA } from '@/utilidades/errores'

export const ObtienePersonaMixin = {
  data: () => ({
    consumiendoPersona: false,
  }),
  methods: {
    // Metodos publicos
    obtienePersona(persona = null) {
      this.$_ObtienePersonaMixin_IniciaObtienePersona()
      personaService
        .obtenerPersona(persona)
        .then((result) => {
          this.$_ObtienePersonaMixin_TerminaObtienePersona()
          if (result.status != 200) {
            this.errorObtienePersona(ERROR_OBTENER_DATOS_PERSONA)
            return
          }
          const data = result.data
          if (data.Codigo != 200) {
            this.errorObtienePersona(data.Mensaje)
            return
          }
          this.postObtienePersona(data.Modelo)
        })
        .catch((err) => {
          this.$_ObtienePersonaMixin_TerminaObtienePersona()
          console.error(err)
          this.errorObtienePersona(ERROR_OBTENER_DATOS_PERSONA)
        })
    },
    postObtienePersona() {},
    errorObtienePersona(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_ObtienePersonaMixin_IniciaObtienePersona() {
      this.consumiendoPersona = true
    },
    $_ObtienePersonaMixin_TerminaObtienePersona() {
      this.consumiendoPersona = false
    },
  },
}
